import { useEffect, useRef, useState } from "react";
import { HERO_SPLINE_URL } from "@/components/sections/hero/heroShared";
import HeroSplineLoadingOverlay from "@/components/sections/hero/HeroSplineLoadingOverlay";

const LOAD_TIMEOUT_MS = 12000;

/** Vesper Spline — full-bleed hero background (native iframe sizing, no extra zoom layer). */
export default function HeroSplineBgEmbed({ onReady }) {
  const [ready, setReady] = useState(false);
  const notifiedRef = useRef(false);

  const markReady = () => {
    if (notifiedRef.current) return;
    notifiedRef.current = true;
    setReady(true);
    onReady?.();
  };

  useEffect(() => {
    const timer = window.setTimeout(markReady, LOAD_TIMEOUT_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <>
      <HeroSplineLoadingOverlay visible={!ready} />
      <iframe
        src={HERO_SPLINE_URL}
        title="DSite hero background"
        className={`ds-hero-spline-bg-embed${ready ? " is-ready" : ""}`}
        frameBorder="0"
        width="100%"
        height="100%"
        loading="eager"
        onLoad={markReady}
      />
    </>
  );
}
